
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { getTaskState } from "@/utils/DataConversionUtils";
import { FloorTaskStatus } from "@/model/CleanTaskingInfo";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "BasicInfo",
  props: {
    floorTaskStatus: {
      type: Object as PropType<FloorTaskStatus>,
      required: true,
      defualt: "",
    },
  },
  emits: ["listen-map-id"],
  setup(props, context) {
    const { t } = useI18n();
    const mapId = ref<string>();
    const mfloorTaskStatus = computed<FloorTaskStatus>(
      () => props.floorTaskStatus
    );

    const currentTaskIndex = computed<number>(
      () => props.floorTaskStatus?.current_task_index
    );

    const check = (val: string) => {
      mapId.value = val;
      context.emit("listen-map-id", val);
    };

    const getCurrentIndexMapId = () => {
      let mapId: string | undefined;
      mfloorTaskStatus.value?.composite_task_list?.some((val) => {
        if (val?.current_parent_task_index == currentTaskIndex.value) {
          mapId = val.map_id;
          return true;
        } else {
          return false;
        }
      });
      return mapId;
    };

    watch(currentTaskIndex, () => {
      const mapId = getCurrentIndexMapId();
      if (mapId) {
        check(mapId);
      }
    });

    return {
      getTaskState,
      mapId,
      check,
      mfloorTaskStatus,
      t,
    };
  },
});
